import { $t } from '../../i18n'
import { BaseAPIError } from './BaseAPIError'

export class UnableRefreshTokenAPIError extends BaseAPIError {
  constructor(options?: ErrorOptions) {
    super($t('Unable to refresh access token'), options)
  }
}
